(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("Xrk", [], factory);
	else if(typeof exports === 'object')
		exports["Xrk"] = factory();
	else
		root["Xrk"] = factory();
})(typeof self !== 'undefined' ? self : this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 1);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'XrkSlideVerify',
  props: {
    options: {
      type: [Object],
      default: function _default() {
        return {
          remoteTimerInterval: 800,
          errorText: '请控制拼图块对齐缺口',
          successText: '验证成功',
          remoteApi: {
            // 获取图片，拼图Y轴
            initImages: '',
            // 验证接口
            checkVerification: ''
          },
          errorAnimationDuration: 0
        };
      }
    }
  },
  data: function data() {
    return {
      visible: false,
      error: false,
      success: false,
      startBtnX: 0,
      requestLock: false,
      remoteTimerId: '',
      remoteTimerInterval: 600,
      animationDuration: 300,
      y: '',
      x: ''
    };
  },

  watch: {
    'visible': {
      handler: function handler(v, oldv) {
        if (v) {
          this.initImg();
        }
      },
      immediate: true
    }
  },
  methods: {
    refresh: function refresh() {
      this.error = false;
      this.initImg();
    },
    close: function close() {
      this.$refs['imgBg'].src = '';
      this.$refs['imgIcon'].src = '';
      Object.assign(this.$data, this.$options.data());
    },

    // 初始化图片
    initImg: function initImg() {
      var _this = this;

      this.startBtnX = 0;
      var rangeBtn = this.$refs['rangeBtn'];
      var imgBg = this.$refs['imgBg'];
      var imgIcon = this.$refs['imgIcon'];
      return new Promise(function (resolve, reject) {
        _this.options['remoteApi'].getVerification().then(function (res) {
          var _res$data$data = res.data.data,
              shadeImage = _res$data$data.shadeImage,
              cutoutImage = _res$data$data.cutoutImage,
              y = _res$data$data.y;

          console.log();
          var rangeBtn = _this.$refs['rangeBtn'];
          rangeBtn.style.left = '0px';
          imgIcon.style.left = '0px';
          imgBg.src = 'data:image/jpg;base64,' + shadeImage;
          imgIcon.src = 'data:image/png;base64,' + cutoutImage;
          imgIcon.style.top = y + 'px';
          // FIXME
          _this.y = y;
          resolve();
        }).catch(reject);
      });
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    var rangeBtn = this.$refs['rangeBtn'];
    var rangeMask = this.$refs['rangeMask'];
    var imgBg = this.$refs['imgBg'];
    var imgIcon = this.$refs['imgIcon'];

    // 移动滑块
    var moveRangeBtn = function moveRangeBtn(e) {
      e.preventDefault();
      if (e.type === 'mousemove') {
        rangeBtn.style.left = Math.max(0, e.offsetX - _this2.startBtnX) + 'px';
        imgIcon.style.left = Math.max(0, e.offsetX - _this2.startBtnX) + 'px';
      }
      if (e.type === 'touchmove') {
        console.log(e.touches[0]);
      }
    };

    // 按下鼠标 监听 move 和 leave
    rangeMask.addEventListener('mousedown', function (e) {

      if (e.offsetX > rangeBtn.offsetWidth || e.offsetX < 0) return;

      // 点击区域 是按钮的位置
      _this2.startBtnX = e.offsetX;
      rangeMask.addEventListener('mousemove', moveRangeBtn);
      // 抬起或者离开，监听一种即可
      rangeMask.addEventListener('mouseup', remoteVerification);
      rangeMask.addEventListener('mouseup', function () {
        return rangeMask.removeEventListener('mouseleave', remoteVerification);
      });
      rangeMask.addEventListener('mouseup', function () {
        return rangeMask.removeEventListener('mousemove', moveRangeBtn);
      });

      rangeMask.addEventListener('mouseleave', remoteVerification);
      rangeMask.addEventListener('mouseleave', function () {
        return rangeMask.removeEventListener('mouseup', remoteVerification);
      });
      rangeMask.addEventListener('mouseleave', function () {
        return rangeMask.removeEventListener('mousemove', moveRangeBtn);
      });
    }, false);

    // 服务器验证
    var remoteVerification = function remoteVerification(e) {
      if (_this2.requestLock) return;
      _this2.requestLock = true;

      var x = e.offsetX - _this2.startBtnX;
      _this2.options['remoteApi'].checkVerification({ x: x, y: _this2.y }).then(function (res) {
        // const { status } = res;
        _this2.remoteTimerId = setTimeout(function () {
          _this2.requestLock = false;
          clearTimeout(_this2.remoteTimerId);
        }, _this2.remoteTimerInterval);

        // 验证通过
        // if (+status === 1) {
        console.log('验证通过。。。');
        _this2.error = false;
        _this2.success = true;
        _this2.animationTimer = setTimeout(function () {
          _this2.success = false;
          // 初始化样式
          imgBg.src = '';
          imgIcon.src = '';
          imgIcon.style.top = '0px';
          rangeBtn.style.left = '0px';
          imgIcon.style.left = '0px';

          _this2.error = false;
          _this2.visible = false;
          _this2.requestLock = false;
          _this2.$emit('success');
        }, 1000);
      }).catch(function () {
        console.log('err');
        console.log('验证失败。。。');
        imgIcon.style.animation = 'jitter ' + _this2.animationDuration + 'ms';
        rangeBtn.style.animation = 'jitter ' + _this2.animationDuration + 'ms';

        _this2.error = true;
        _this2.animationTimer = setTimeout(function () {
          //初始化图片信息
          _this2.initImg().then(function () {
            clearTimeout(_this2.animationTimer);
            imgIcon.style.animation = '';
            rangeBtn.style.animation = '';
          });
          _this2.requestLock = false;
        }, _this2.animationDuration);
      });
    };
  },
  destroyed: function destroyed() {
    clearTimeout(this.remoteTimerId);
  }
});

/***/ }),
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__packages_slide_verify_index_js__ = __webpack_require__(2);
/*
 * @Description:
 * @LastEditors: wjx
 * @Date: 2021-01-28 23:29:19
 */


var components = [__WEBPACK_IMPORTED_MODULE_0__packages_slide_verify_index_js__["a" /* default */]];

var install = function install(Vue) {
  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  components.forEach(function (component) {
    Vue.component(component.name, component);
  });
};

if (typeof window !== "undefined" && window.Vue) {
  install(window.Vue);
}

/* harmony default export */ __webpack_exports__["default"] = ({
  install: install,
  SlideVerify: __WEBPACK_IMPORTED_MODULE_0__packages_slide_verify_index_js__["a" /* default */]
});

/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_main__ = __webpack_require__(3);
/*
 * @Description: 
 * @LastEditors: wjx
 * @Date: 2021-01-29 00:40:03
 */


__WEBPACK_IMPORTED_MODULE_0__src_main__["a" /* default */].install = function (Vue) {
  Vue.component(__WEBPACK_IMPORTED_MODULE_0__src_main__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_0__src_main__["a" /* default */]);
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__src_main__["a" /* default */]);

/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_main_vue__ = __webpack_require__(0);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_3a692bb5_hasScoped_false_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_main_vue__ = __webpack_require__(13);
function injectStyle (ssrContext) {
  __webpack_require__(4)
}
var normalizeComponent = __webpack_require__(12)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_main_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_3a692bb5_hasScoped_false_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_main_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(5);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(10)("3fc82561", content, true, {});

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

var escape = __webpack_require__(6);
exports = module.exports = __webpack_require__(7)(false);
// imports


// module
exports.push([module.i, ".fade-enter-active,.fade-leave-active{transition:opacity .5s}.fade-enter,.fade-leave-to{opacity:0}@keyframes jitter{0%{transform:translateX(0)}25%{transform:translateX(-5px)}50%{transform:translateX(5px)}75%{transform:translateX(-5px)}to{transform:translateX(0)}}.v-box{position:relative;user-select:none}.v-box_box{position:absolute;right:10px;bottom:0;width:310px;height:348px;background-color:#fff;border-radius:8px;z-index:9999;box-shadow:2px 4px 20px #2e2f2f;padding:16px 12px}.v-box_title{font-size:20px;line-height:20px;margin-bottom:16px;text-align:center}.v-box_sub,.v-box_title{font-weight:400;font-stretch:normal;letter-spacing:0;color:#141413}.v-box_sub{font-size:14px;line-height:14px;padding-bottom:12px}.v-box_close{position:absolute;right:8px;top:8px;width:24px;height:24px;border-radius:14px;background:url(" + escape(__webpack_require__(8)) + ");cursor:pointer}.v-box_img{border-radius:6px;position:relative;overflow:hidden}.v-box_img,.v-box_img_bg{width:280px;height:171px}.v-box_img_icon{position:absolute;top:0;left:0;width:55px;height:55px}.v-box_range{margin-top:20px;height:40px;position:relative;box-sizing:border-box;display:flex;align-items:center}.v-box_range_track{width:286px;height:12px;background-color:#f0f0ef;border-radius:6px;position:relative}.v-box_range_btn{width:36px;height:28px;box-shadow:0 0 4px 0 #f7e00b;border-radius:14px;border:none;box-sizing:border-box;outline:none;position:absolute;background:url(" + escape(__webpack_require__(9)) + ");background-size:100% 100%;left:0}.v-box_range_mask{position:absolute;top:0;left:0;width:100%;height:40px;z-index:9999;cursor:pointer}.v-box_foot{display:flex;justify-content:space-between;align-items:center}.v-box_foot_refresh{width:28px;height:28px;cursor:pointer}", ""]);

// exports


/***/ }),
/* 6 */
/***/ (function(module, exports) {

module.exports = function escape(url) {
    if (typeof url !== 'string') {
        return url
    }
    // If url is already wrapped in quotes, remove them
    if (/^['"].*['"]$/.test(url)) {
        url = url.slice(1, -1);
    }
    // Should url be wrapped?
    // See https://drafts.csswg.org/css-values-3/#urls
    if (/["'() \t\n]/.test(url)) {
        return '"' + url.replace(/"/g, '\\"').replace(/\n/g, '\\n') + '"'
    }

    return url
}


/***/ }),
/* 7 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function(useSourceMap) {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		return this.map(function (item) {
			var content = cssWithMappingToString(item, useSourceMap);
			if(item[2]) {
				return "@media " + item[2] + "{" + content + "}";
			} else {
				return content;
			}
		}).join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};

function cssWithMappingToString(item, useSourceMap) {
	var content = item[1] || '';
	var cssMapping = item[3];
	if (!cssMapping) {
		return content;
	}

	if (useSourceMap && typeof btoa === 'function') {
		var sourceMapping = toComment(cssMapping);
		var sourceURLs = cssMapping.sources.map(function (source) {
			return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */'
		});

		return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
	}

	return [content].join('\n');
}

// Adapted from convert-source-map (MIT)
function toComment(sourceMap) {
	// eslint-disable-next-line no-undef
	var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
	var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;

	return '/*# ' + data + ' */';
}


/***/ }),
/* 8 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAAGXcA1uAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAGKADAAQAAAABAAAAGAAAAADiNXWtAAADJElEQVRIDZVVz2sTQRSe2W4qJDRZaaE02jbYIjl76ck/QLQWwd68CAoBQVFSsFgQ7wWheAi24MVbBalg/gFPOddDKhFS0UJObhIawU2yvm+SN5mdrq0OtPvm/X7zvvciBJ1ms/mg0+lcHAOxsHDpVafz64kAZ2PjWTg1NRlCS/j+zza+kogBhy4OOHwkCFOKu5Sy77AtGIuLi/iIMAwdZdFs+j1cFJf+Sek8YpqS8w/or8wM2Wq1bvb7vT1m4Ot556VjMnd33yk5ktF+wVxdva0NVSGNRkNMT0+PmFL2YutADCWAalwS2oUQbVJO4x7ryVAUtVpNPwip71AP/ANSmDSV8GIzM1lRLpfF8vINU3RF4nHo9a4xF1UeHtZFsVhUnhHBPJxSi5gTpiCOTiTGL+iioeD7/ja17p6pTB3uuW5iLpVKHZl8RQNGSBEIQG3AmK2kI5DSX9NynLGVdDr9AcbKgLxFYGN7xZ2NCID+NmOsWq2e0O12u4rHICLQjIrc3/8sNjc3tRH64bquvqOmyFRAwn0olUqqy1qbCHqxLyPzoQTQhOdCoWDqKppSz2ocsxTK6O78fC6SHuQU4ROg0SXLMTBYGTQO0pubmxVLS0vqPj5+blYeHx9ng+D3D8U5/Z+CuIOWR8Y1xggLgOdB1ZDJZLYUsAg3J/XlTibjqZQh09AwFQdpBi9oHu9yfabcpCk6oUS8SSQSz+MAGglAjXxIjX/JSDEd/QuNUinnx6iQ9VWA4cMCd2fOHBue8W3TE+ZRkYMR63aDb7ZzrDa03YSu7RQwgE6lUrFFE/AJ3w5B4nXcO2NvMgDtQOy4Xq8rHcaZGQU+4dsh4qopsGmMhhkIwbDjwFtbK9rqkTt8u9SYIyIuRyTWBRmvrz9V84eRAo2DRXragW/CtdQdt5X5KThjOLQrOq1H8K1QFLd8EQwLLZ/P23EjdzxVLpeL7K2BgtzxPO++ngP8tIVh/z0914mNE/F4xgWzQKvhVmRnmzbD39C3xPvfmWjTXr/DjtmnroAZ5hc4DoJghab7OvEXqLos5Ggefb4S9ZFWxF4ymfwOftz5AwafpSsKk5uRAAAAAElFTkSuQmCC"

/***/ }),
/* 9 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

/*
  MIT License http://www.opensource.org/licenses/mit-license.php
  Author Tobias Koppers @sokra
  Modified by Evan You @yyx990803
*/

var hasDocument = typeof document !== 'undefined'

if (typeof DEBUG !== 'undefined' && DEBUG) {
  if (!hasDocument) {
    throw new Error(
    'vue-style-loader cannot be used in a non-browser environment. ' +
    "Use { target: 'node' } in your Webpack config to indicate a server-rendering environment."
  ) }
}

var listToStyles = __webpack_require__(11)

/*
type StyleObject = {
  id: number;
  parts: Array<StyleObjectPart>
}

type StyleObjectPart = {
  css: string;
  media: string;
  sourceMap: ?string
}
*/

var stylesInDom = {/*
  [id: number]: {
    id: number,
    refs: number,
    parts: Array<(obj?: StyleObjectPart) => void>
  }
*/}

var head = hasDocument && (document.head || document.getElementsByTagName('head')[0])
var singletonElement = null
var singletonCounter = 0
var isProduction = false
var noop = function () {}
var options = null
var ssrIdKey = 'data-vue-ssr-id'

// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
// tags it will allow on a page
var isOldIE = typeof navigator !== 'undefined' && /msie [6-9]\b/.test(navigator.userAgent.toLowerCase())

module.exports = function (parentId, list, _isProduction, _options) {
  isProduction = _isProduction

  options = _options || {}

  var styles = listToStyles(parentId, list)
  addStylesToDom(styles)

  return function update (newList) {
    var mayRemove = []
    for (var i = 0; i < styles.length; i++) {
      var item = styles[i]
      var domStyle = stylesInDom[item.id]
      domStyle.refs--
      mayRemove.push(domStyle)
    }
    if (newList) {
      styles = listToStyles(parentId, newList)
      addStylesToDom(styles)
    } else {
      styles = []
    }
    for (var i = 0; i < mayRemove.length; i++) {
      var domStyle = mayRemove[i]
      if (domStyle.refs === 0) {
        for (var j = 0; j < domStyle.parts.length; j++) {
          domStyle.parts[j]()
        }
        delete stylesInDom[domStyle.id]
      }
    }
  }
}

function addStylesToDom (styles /* Array<StyleObject> */) {
  for (var i = 0; i < styles.length; i++) {
    var item = styles[i]
    var domStyle = stylesInDom[item.id]
    if (domStyle) {
      domStyle.refs++
      for (var j = 0; j < domStyle.parts.length; j++) {
        domStyle.parts[j](item.parts[j])
      }
      for (; j < item.parts.length; j++) {
        domStyle.parts.push(addStyle(item.parts[j]))
      }
      if (domStyle.parts.length > item.parts.length) {
        domStyle.parts.length = item.parts.length
      }
    } else {
      var parts = []
      for (var j = 0; j < item.parts.length; j++) {
        parts.push(addStyle(item.parts[j]))
      }
      stylesInDom[item.id] = { id: item.id, refs: 1, parts: parts }
    }
  }
}

function createStyleElement () {
  var styleElement = document.createElement('style')
  styleElement.type = 'text/css'
  head.appendChild(styleElement)
  return styleElement
}

function addStyle (obj /* StyleObjectPart */) {
  var update, remove
  var styleElement = document.querySelector('style[' + ssrIdKey + '~="' + obj.id + '"]')

  if (styleElement) {
    if (isProduction) {
      // has SSR styles and in production mode.
      // simply do nothing.
      return noop
    } else {
      // has SSR styles but in dev mode.
      // for some reason Chrome can't handle source map in server-rendered
      // style tags - source maps in <style> only works if the style tag is
      // created and inserted dynamically. So we remove the server rendered
      // styles and inject new ones.
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  if (isOldIE) {
    // use singleton mode for IE9.
    var styleIndex = singletonCounter++
    styleElement = singletonElement || (singletonElement = createStyleElement())
    update = applyToSingletonTag.bind(null, styleElement, styleIndex, false)
    remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true)
  } else {
    // use multi-style-tag mode in all other cases
    styleElement = createStyleElement()
    update = applyToTag.bind(null, styleElement)
    remove = function () {
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  update(obj)

  return function updateStyle (newObj /* StyleObjectPart */) {
    if (newObj) {
      if (newObj.css === obj.css &&
          newObj.media === obj.media &&
          newObj.sourceMap === obj.sourceMap) {
        return
      }
      update(obj = newObj)
    } else {
      remove()
    }
  }
}

var replaceText = (function () {
  var textStore = []

  return function (index, replacement) {
    textStore[index] = replacement
    return textStore.filter(Boolean).join('\n')
  }
})()

function applyToSingletonTag (styleElement, index, remove, obj) {
  var css = remove ? '' : obj.css

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = replaceText(index, css)
  } else {
    var cssNode = document.createTextNode(css)
    var childNodes = styleElement.childNodes
    if (childNodes[index]) styleElement.removeChild(childNodes[index])
    if (childNodes.length) {
      styleElement.insertBefore(cssNode, childNodes[index])
    } else {
      styleElement.appendChild(cssNode)
    }
  }
}

function applyToTag (styleElement, obj) {
  var css = obj.css
  var media = obj.media
  var sourceMap = obj.sourceMap

  if (media) {
    styleElement.setAttribute('media', media)
  }
  if (options.ssrId) {
    styleElement.setAttribute(ssrIdKey, obj.id)
  }

  if (sourceMap) {
    // https://developer.chrome.com/devtools/docs/javascript-debugging
    // this makes source maps inside style tags work properly in Chrome
    css += '\n/*# sourceURL=' + sourceMap.sources[0] + ' */'
    // http://stackoverflow.com/a/26603875
    css += '\n/*# sourceMappingURL=data:application/json;base64,' + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + ' */'
  }

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = css
  } else {
    while (styleElement.firstChild) {
      styleElement.removeChild(styleElement.firstChild)
    }
    styleElement.appendChild(document.createTextNode(css))
  }
}


/***/ }),
/* 11 */
/***/ (function(module, exports) {

/**
 * Translates the list format produced by css-loader into something
 * easier to manipulate.
 */
module.exports = function listToStyles (parentId, list) {
  var styles = []
  var newStyles = {}
  for (var i = 0; i < list.length; i++) {
    var item = list[i]
    var id = item[0]
    var css = item[1]
    var media = item[2]
    var sourceMap = item[3]
    var part = {
      id: parentId + ':' + i,
      css: css,
      media: media,
      sourceMap: sourceMap
    }
    if (!newStyles[id]) {
      styles.push(newStyles[id] = { id: id, parts: [part] })
    } else {
      newStyles[id].parts.push(part)
    }
  }
  return styles
}


/***/ }),
/* 12 */
/***/ (function(module, exports) {

/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file.
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = injectStyles
  }

  if (hook) {
    var functional = options.functional
    var existing = functional
      ? options.render
      : options.beforeCreate

    if (!functional) {
      // inject component registration as beforeCreate hook
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    } else {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functioal component in vue file
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return existing(h, context)
      }
    }
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"v-box",staticStyle:{"display":"inline-block"}},[_vm._t("default"),_vm._v(" "),_c('transition',{attrs:{"name":"fade"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.visible),expression:"visible"}],staticClass:"v-box_box"},[_c('i',{staticClass:"v-box_close",on:{"click":_vm.close}}),_vm._v(" "),_c('p',{staticClass:"v-box_title"},[_vm._v("安全验证")]),_vm._v(" "),_c('p',{staticClass:"v-box_sub"},[_vm._v("拖动下方滑块完成拼图")]),_vm._v(" "),_c('div',{ref:"imgWrap",staticClass:"v-box_img"},[_c('img',{ref:"imgBg",staticClass:"v-box_img_bg",attrs:{"src":"","alt":""}}),_vm._v(" "),_c('img',{ref:"imgIcon",staticClass:"v-box_img_icon",attrs:{"src":"","alt":""}})]),_vm._v(" "),_c('div',{ref:"range",staticClass:"v-box_range"},[_c('div',{staticClass:"v-box_range_track"}),_vm._v(" "),_c('button',{ref:"rangeBtn",staticClass:"v-box_range_btn"}),_vm._v(" "),_c('div',{ref:"rangeMask",staticClass:"v-box_range_mask"})]),_vm._v(" "),_c('div',{staticClass:"v-box_foot"},[_c('div',[(_vm.error)?_c('span',{staticStyle:{"color":"#FF0000"}},[_vm._v("\n          "+_vm._s(_vm.options.errorText)+"\n        ")]):_vm._e(),_vm._v(" "),(_vm.success)?_c('span',{staticStyle:{"color":"#00ff5d"}},[_vm._v("\n          "+_vm._s(_vm.options.successText)+"\n        ")]):_vm._e()]),_vm._v(" "),_c('img',{staticClass:"v-box_foot_refresh",attrs:{"src":__webpack_require__(14),"alt":""},on:{"click":_vm.refresh}})])])])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 14 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ })
/******/ ])["default"];
});


// WEBPACK FOOTER //
// build.js